import { LOCAL_STORAGE_KEY } from "../../constants";
import Routers from "../../constants/routers";

type Redirect = (url: string) => void;

export const completeLocalLogout = (redirect: Redirect = (url) => window.location.assign(url)) => {
  localStorage.removeItem(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
  redirect(window.location.origin + Routers.Login);
};
